// extracted by mini-css-extract-plugin
module.exports = {"screenSizeIndicator":"styles__screenSizeIndicator___2yPHt","mobile":"styles__mobile___1xXwo","tablet":"styles__tablet___3xXKR","desktop":"styles__desktop___B9XtP"};